interface Category {
  name: string;
  icon: string; // Icon identifier
  color: string; // Hex color for background
}
const categories: Category[] = [
  { name: 'Telegram', icon: 'ic:baseline-telegram', color: '#3F9EF6' },
  { name: 'Gaming', icon: 'icon-park-solid:game-ps', color: '#F1BF0B' },
  { name: 'Crypto', icon: 'cryptocurrency:kcs', color: '#8B5BF1' },
  { name: 'Gambling', icon: 'ic:baseline-casino', color: '#31DE91' },
  { name: 'Promotions', icon: 'mdi:stars', color: '#F1BF0B' },
  { name: 'News & Media', icon: 'material-symbols:news', color: '#3F9EF6' },
  { name: 'Earnings', icon: 'raphael:dollar', color: '#31DE91' },
  { name: 'Trading', icon: 'icon-park-solid:trend', color: '#8B5BF1' },
  { name: 'Education', icon: 'tdesign:education-filled', color: '#3F9EF6' },
  { name: 'Other', icon: 'mdi:help-circle', color: '#CCCCCC' } // Added "Other"
];

export default categories;
